import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardChecks: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'card-checks',
  params: {
    loader: async () =>
      import('./entity-card-checks').then(m => <m.EntityCardChecks />),
  },
});
